import { DateTimePicker, DateTimePickerProps } from '@mantine/dates';
import React from 'react';

/**
 * Date & time input for forms. Defaults follow the LIA Assessment Schedule form,
 * which is the baseline for every menu.
 */
const DateTimeField: React.FC<DateTimePickerProps> = ({
  placeholder = 'Select date and time',
  ...props
}) => <DateTimePicker placeholder={placeholder} {...props} />;

export default DateTimeField;
